/**
 * TOOJ Size Chart — row/column hover + PDP modal
 */
(function () {
  function init(root) {
    if (!root || root.dataset.tscReady === 'true') return;
    root.dataset.tscReady = 'true';

    var table = root.querySelector('[data-tsc-table]');
    if (!table) return;

    var cells = Array.prototype.slice.call(table.querySelectorAll('[data-tsc-cell]'));
    var heightCells = Array.prototype.slice.call(table.querySelectorAll('[data-tsc-height]'));
    var headCells = Array.prototype.slice.call(table.querySelectorAll('[data-tsc-col]'));

    function clear() {
      cells.forEach(function (el) {
        el.classList.remove('is-row-hover', 'is-col-hover', 'is-active');
      });
      heightCells.forEach(function (el) {
        el.classList.remove('is-row-hover');
      });
      headCells.forEach(function (el) {
        el.classList.remove('is-col-hover');
      });
    }

    function highlight(row, col, active) {
      clear();
      cells.forEach(function (el) {
        var r = el.getAttribute('data-row');
        var c = el.getAttribute('data-col');
        if (r === row) el.classList.add('is-row-hover');
        if (c === col) el.classList.add('is-col-hover');
        if (active && r === row && c === col) el.classList.add('is-active');
      });
      heightCells.forEach(function (el) {
        if (el.getAttribute('data-row') === row) el.classList.add('is-row-hover');
      });
      headCells.forEach(function (el) {
        if (el.getAttribute('data-col') === col) el.classList.add('is-col-hover');
      });
    }

    cells.forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        highlight(el.getAttribute('data-row'), el.getAttribute('data-col'), false);
      });
      el.addEventListener('focus', function () {
        highlight(el.getAttribute('data-row'), el.getAttribute('data-col'), true);
      });
      el.addEventListener('click', function () {
        highlight(el.getAttribute('data-row'), el.getAttribute('data-col'), true);
      });
    });

    table.addEventListener('mouseleave', clear);
  }

  function bootCharts() {
    document.querySelectorAll('[data-tooj-size-chart]').forEach(init);
  }

  function initModal() {
    var modal = document.querySelector('[data-tooj-size-chart-modal]');
    if (!modal || modal.dataset.tscModalReady === 'true') return;
    modal.dataset.tscModalReady = 'true';

    /* Escape PDP #MainContent color locks */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var dialog = modal.querySelector('[data-tooj-size-chart-dialog]');
    var lastFocus = null;
    var closeTimer = null;
    var ANIM_MS = 560;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function openModal() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      lastFocus = document.activeElement;
      modal.classList.remove('is-open', 'is-closing');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tooj-size-chart-modal-open');
      bootCharts();
      void modal.offsetWidth;
      modal.classList.add('is-open');
      if (dialog) dialog.focus();
    }

    function finishClose() {
      modal.classList.remove('is-open', 'is-closing');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tooj-size-chart-modal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function closeModal() {
      if (modal.hidden && !modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.classList.add('is-closing');
      if (prefersReducedMotion()) {
        finishClose();
        return;
      }
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(finishClose, ANIM_MS);
    }

    document.querySelectorAll('[data-tooj-size-chart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    modal.querySelectorAll('[data-tooj-size-chart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function boot() {
    bootCharts();
    initModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-tooj-size-chart]')
      : null;
    if (root) {
      root.dataset.tscReady = 'false';
      init(root);
    }
    initModal();
  });
})();
